import React, { PureComponent } from "react";
import {withTranslation} from "react-i18next";
import SliderContainer from "../../containers/SliderContainer";
import PropTypes from "prop-types";
import { dataCreditsValueMap } from "../../lib/filters";
import { formatDataCredits } from "../../lib/formatData";
import { getKeyByValue } from "../../lib/utils";

class DataCreditsFilter extends PureComponent {
  render() {
    const { decimalSeparator, portalId, showShort, t } = this.props;

    return (
      <SliderContainer
        {...this.props}
        convertedValueFunction={function(amount) {
          return formatDataCredits(amount, {
            asString: true,
            decimalSeparator: decimalSeparator,
            showShort: showShort
          });
        }}
        convertedValuePrefix={`${t("dataCreditsPrefix")} `}
        componentValue={this.componentValue()}
        invertedColors
        labels={[0, this.unlimitedLabel()]}
        title={t("dataCreditsTitle")}
        valueMap={dataCreditsValueMap(portalId)}
      />
    );
  }

  componentValue() {
    const { componentMappedValue, componentValue, portalId } = this.props;

    let mappedValue;

    if (componentMappedValue != null) {
      mappedValue = getKeyByValue(
        dataCreditsValueMap(portalId),
        componentMappedValue
      );
    }

    if (mappedValue != null) {
      return parseInt(mappedValue, 10);
    } else {
      return componentValue;
    }
  }

  unlimitedLabel() {
    const { labelShort, t } = this.props;

    if (labelShort) {
      return t("unlimitedShort");
    } else {
      return t("unlimited");
    }
  }
}

DataCreditsFilter.propTypes = {
  decimalSeparator: PropTypes.string.isRequired,
  componentMappedValue: PropTypes.number,
  componentValue: PropTypes.number,
  labelShort: PropTypes.bool,
  portalId: PropTypes.string.isRequired,
  showShort: PropTypes.bool.isRequired
};

DataCreditsFilter.defaultProps = {
  labelShort: false,
  showShort: false
};

export default withTranslation(["filters", "dataCredits"])(DataCreditsFilter);
